export default (ctx, html) => html`
  <div class="chart-wrapper">
    <div class="position-absolute chart-overlay">
      <slot name="overlay"></slot>
    </div>
    <div class="position-relative">
      <canvas tabindex=0 style="max-height:${ctx.maxHeight};" role="img"></canvas>
    </div>
  </div>
`;
